import {
  choiceComponentWithId,
  flattenRichText,
  paragraphsForParagraphCollectionComponentWithId,
  stringForSingleLineComponentWithId,
} from "../../mapper/api-mappers";
import { DataMapper } from "..";
import { BlogPage } from "~/use-cases/contracts/BlogPage";
import { ProductSlim } from "~/use-cases/contracts/Product";
import { CuratedStorySlim, StorySlim } from "~/use-cases/contracts/Story";
import { isVisibleInCurrentShop } from "~/use-cases/shop-visibility";

export default function FetchFolderToBlog(data: any): BlogPage {
  const mapper = DataMapper();
  const firstSeoChunk = data.meta?.content?.chunks[0];

  const description = data.components.find(
    (c: any) => c.id === "description",
  )?.content;

  const visiblePosts = (data.children ?? []).filter((child: any) =>
    isVisibleInCurrentShop(child.components),
  );

  const dto: BlogPage = {
    name: data.name,
    path: data.path,
    title:
      stringForSingleLineComponentWithId(data.components, "title") ||
      data.name!,
    description: description,
    seo: mapper.API.Object.APIMetaSEOComponentToSEO(firstSeoChunk),
    blogPosts: visiblePosts.map(
      (child: any): CuratedStorySlim | StorySlim | undefined => {
        const common = {
          name: child.name,
          path: child.path,
        };
        if (child.shape.identifier === "story") {
          const title =
            stringForSingleLineComponentWithId(child.components, "title") ||
            child.name!;
          const intro = child.components.find(
            (c: any) => c.id === "intro",
          )?.content;
          const media = choiceComponentWithId(child.components, "media");
          return {
            ...common,
            title,
            description: intro,
            type: "story",
            medias: {
              images:
                media?.id === "image"
                  ? mapper.API.Object.APIImageToImage(media.content.images)
                  : [],
              videos: media?.id === "video" ? [] : [], // @todo: to be implemented
            },
          };
        }
      },
    ),
  };

  return dto;
}
